import type { CanActivateFn, Routes } from '@angular/router';

export function createWorkflowOperationAppRoutes(
  workflowOperationsEnabledGuard: CanActivateFn,
): Routes {
  return [
    {
      path: 'workflow-operations/start',
      redirectTo: 'workflows',
      pathMatch: 'full',
    },
    {
      path: 'workflow-operations/history',
      redirectTo: 'workflows/history',
      pathMatch: 'full',
    },
    {
      path: 'workflow-operations',
      redirectTo: 'workflows',
      pathMatch: 'full',
    },
    {
      path: 'workflows',
      loadChildren: () =>
        import('./workflow-operations.routes').then(
          (module) => module.workflowOperationRoutes,
        ),
      canActivate: [workflowOperationsEnabledGuard],
    },
  ];
}
